import { render, staticRenderFns } from "./bank-transactions-list.vue?vue&type=template&id=c4ca55b4&"
import script from "./bank-transactions-list.vue?vue&type=script&lang=js&"
export * from "./bank-transactions-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports